import Text from 'approot/shared/styles/typography/text';
import * as Styled from './multiple-choice-student-hint.style';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import IconClose from 'approot/shared/icons/icon-close';
import { Box } from 'approot/shared/design-system/box/box.style';
import IconLightBulb from 'approot/shared/icons/icon-light-bulb';

type Props = {
  hint: string;
  onClose: () => void;
};

const MultipleChoiceStudentHint = ({ hint, onClose }: Props) => {
  return (
    <Styled.MultipleChoiceStudentHint>
      <Box $gap={8} $alignItems="center" $flexWrap="nowrap">
        <IconLightBulb width={24} height={24} />
        <Text>{hint}</Text>
        <SecondaryButtonIcon
          type="button"
          aria-label="Close hint"
          $isSmall
          $noBorder
          $borderRadius={40}
          onClick={onClose}
        >
          <IconClose width={16} height={16} />
        </SecondaryButtonIcon>
      </Box>
    </Styled.MultipleChoiceStudentHint>
  );
};

export default MultipleChoiceStudentHint;
